import { useEffect, useState } from 'react'

/**
 * The value as it was `delayMs` ago, once it stops changing.
 *
 * Used for search boxes whose filtering happens on the server: without this,
 * every keystroke is its own request, and the answers can land out of order.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)

    return () => clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
